import { yupResolver } from '@hookform/resolvers/yup';
import { DialogContent, DialogTitle, Grid } from '@mui/material';
import { useState } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { IExcelImportTemplate, saveOrUpdateTemplate } from 'wisestep-api';
import { ControlledTextInput, WsButton, WsDialog } from 'wisestep-base';
import { object, string } from 'yup';

import { failed, success } from '../../../../utils/NotificationMessages';
import { useNotificationStore } from '../../../../utils/NotificationStore';

interface IModelPros {
  mappings: string[];
  getMappings: () => string[];
  uploadingFor: string;
  loadTemplates: (value: boolean) => void;
  isTemplateSelected: boolean;
}
const validationSchema = object().shape({
  name: string().required('Template Name is required'),
});

const SaveExcelTemplateModel = ({
  uploadingFor,
  getMappings,
  loadTemplates,
  isTemplateSelected,
}: IModelPros) => {
  const [open, setOpen] = useState<boolean>(false);

  const setNotification = useNotificationStore((state) => state.setNotification);
  const formOptions = {
    resolver: yupResolver(validationSchema),
  };
  const methods = useForm<IExcelImportTemplate>(formOptions);

  const onSubmit = async (request: IExcelImportTemplate) => {
    request.columnMapping = getMappings().map((data) => (data ? data : ''));
    const response = await saveOrUpdateTemplate(request);
    if (response.status === 200) {
      setNotification(success('Template Save'));
    } else {
      setNotification(failed('Failed to save template'));
    }
    methods.reset({});
    loadTemplates(true);
    setOpen(false);
  };

  const openModel = (isEdit: boolean) => {
    const columnMapping = getMappings().map((data) => (data ? data : ''));
    if (!columnMapping || columnMapping.filter((mapping) => mapping).length === 0) {
      setNotification({ type: 'error', message: 'Please select mappings' });
      return;
    }
    if (isEdit) {
      //   methods.reset({
      //     ...templates[methods.getValues('selectedTemplate')],
      //     columnMapping: columnMapping,
      //   });
    } else {
      methods.setValue('columnMapping', columnMapping);
      methods.setValue('isMapping', uploadingFor === 'mapping');
    }
    setOpen(!open);
  };

  return (
    <FormProvider {...methods}>
      <Grid item xs={3} display="flex" justifyContent={'start'} ml={1}>
        <WsButton fullWidth onClick={() => openModel(false)} disabled={isTemplateSelected}>
          Save Template
        </WsButton>
      </Grid>
      {/* <Grid item xs={4} display="flex" justifyContent={'end'}>
          <WsButton onClick={() => openModel(true)}>Edit Template</WsButton>
        </Grid> */}

      <WsDialog openDialog={open} onClose={() => setOpen(false)}>
        <DialogTitle
          sx={{
            justifyContent: 'center',
          }}
        >
          Save Template
        </DialogTitle>

        <DialogContent>
          <Grid container component="form" onSubmit={methods.handleSubmit(onSubmit)} spacing={2}>
            <Grid item xs={12}>
              <ControlledTextInput
                fullWidth
                name="name"
                placeholder="Template name"
                type="text"
              ></ControlledTextInput>
            </Grid>
            <Grid item xs={12} display="flex" justifyContent="end">
              <WsButton type="submit" size="large">
                Save
              </WsButton>
            </Grid>
          </Grid>
        </DialogContent>
      </WsDialog>
    </FormProvider>
  );
};

export default SaveExcelTemplateModel;
